import { Hooks } from './hooks';
import { append } from './array/append';
import { assign } from './object/assign';
import { deepPrune, prune } from './object/prune';
import { normalizeNumber } from './normalize-number';
import { normalizeString } from './normalize-string';
import { set } from './object/set';
import { toArray } from './array/to-array';
import { update } from './array/update';

export * from 'utils/pick/pick';

export const Utils = {
  Hooks,

  append,
  assign,
  deepPrune,
  normalizeNumber,
  normalizeString,
  prune,
  set,
  toArray,
  update,
};

export { hasFieldsWithValues } from './object/has-fields-with-values';
